// Footer Component
const Footer: React.FC = () => (
    <footer>
      {/* <p>&copy; 2024 Our Shop. All rights reserved.</p> */}
    </footer>
  );
export default Footer;